import React, { FC } from 'react';
import styled from 'styled-components';
import { TypographySize } from '@clds/typography';
import { ButtonSize } from '@clds/button';
import { useOverflowTrigger } from '@cld/use-overflow-trigger';
import { Snippet } from '..';
import { TabsHeader } from './TabsHeader';
import { SnippetsLanguagesMenu } from './SnippetsLanguagesMenu';

export interface ResponsiveHeaderProps {
  snippets: Snippet[];
  activeSnippet: Snippet;
  onSnippetChange: (lang: string) => void;
  tabsSize: TypographySize;
  buttonSize: ButtonSize;
}

const Root = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const DropdownWrapper = styled.div`
  position: absolute;
  top: 0;
`;

export const ResponsiveHeader: FC<React.PropsWithChildren<ResponsiveHeaderProps>> = ({
  snippets,
  activeSnippet,
  onSnippetChange,
  tabsSize,
  buttonSize,
  children,
}) => {
  const { isHorizontalOverflow, elementRef } = useOverflowTrigger<HTMLDivElement>();

  return (
    <Root>
      <TabsHeader
        ref={elementRef}
        isVisible={isHorizontalOverflow}
        activeSnippet={activeSnippet}
        snippets={snippets}
        onSnippetChange={onSnippetChange}
        tabsSize={tabsSize}
      />
      <DropdownWrapper>
        {isHorizontalOverflow && (
          <SnippetsLanguagesMenu snippets={snippets} onSnippetChange={onSnippetChange} activeSnippet={activeSnippet} tone="plain" size={buttonSize} />
        )}
      </DropdownWrapper>
      {children}
    </Root>
  );
};
